<template>
    <div id="review" class="tab-pane fade" v-if="product != null && product.description != null"
        :class="activeTab === 'review' ? 'in active show' :''">
        <p class="fontsize-small text-color-666 text-justify line-height2 p-3" v-html="product.description">
        </p>
    </div>
</template>
<script>
    export default {
        props:['activeTab' , 'product'],
    }
</script>
<style>
@media (max-width:768px){
    div#review img{
        width: 100% !important;
        height: auto !important;
    }
}
</style>
